import { InformationCenterConfigurationModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class InformationCenterMessage extends DomainEntity<InformationCenterConfigurationModelDto> {
    public static from(dto: InformationCenterConfigurationModelDto): InformationCenterMessage {
        return new InformationCenterMessage(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get title() {
        return this.dto.title;
    }

    public set title(value: string) {
        this.dto.title = value;
    }

    public get description() {
        return this.dto.description ?? '';
    }

    public set description(value: string) {
        this.dto.description = value;
    }

    public get descriptionPreview() {
        const text = this.description;
        return text.length > 30 ? `${text.substring(0, 29)}\u2026` : text;
    }

    public get type() {
        return this.dto.type;
    }

    public set type(value: string) {
        this.dto.type = value;
    }

    public get status() {
        return this.dto.status;
    }

    public set status(value: string) {
        this.dto.status = value;
    }

    public get startDate() {
        return this.dto.startDate;
    }

    public set startDate(value: string) {
        this.dto.startDate = value;
    }

    public get endDate() {
        return this.dto.endDate;
    }

    public set endDate(value: string) {
        this.dto.endDate = value;
    }

    public get sequence() {
        return this.dto.sequence ?? 0;
    }

    public get isActive() {
        return this.dto.status === 'Active';
    }
}
